import { Toolbar, AppBar, AppBarProps, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';


const useStyles = makeStyles()(theme => ({
  appBar: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: 'none',
    boxSizing: 'border-box',
  },
  appBarVariantClear: {},
  appBarVariantOutlined: {
    boxShadow: `0px -1px 0 0 ${theme.palette.divider} inset`,
  },
  appBarVariantElevation: {
    boxShadow: theme.shadows[3],
  },
  toolBar: {
    height: '64px',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));


export type NavigationProps = {
  position?: AppBarProps['position'];
  variant?: 'clear' | 'outlined' | 'elevation';
};

export const Navigation = React.forwardRef<HTMLDivElement, React.PropsWithChildren<NavigationProps>>(({
  children,
  position = 'sticky',
  variant = 'outlined',
}, ref) => {
  const { classes, cx } = useStyles();
  const appBarClassName = cx(classes.appBar, {
    [classes.appBarVariantClear]: variant === 'clear',
    [classes.appBarVariantOutlined]: variant === 'outlined',
    [classes.appBarVariantElevation]: variant === 'elevation',
  });

  const needAdditionalSpacer = React.useMemo(() => {
    return [ 'fixed', 'absolute' ].includes(position);
  }, [ position ]);

  if (needAdditionalSpacer) {
    return (
      <Box display="flex">
        <AppBar position={position} className={appBarClassName}>
          <Toolbar className={classes.toolBar}>
            {children}
          </Toolbar>
        </AppBar>
        <Toolbar className={classes.toolBar}/>
      </Box>
    );
  }

  return (
    <AppBar component="div" ref={ref} position={position} className={appBarClassName}>
      <Toolbar className={classes.toolBar}>
        {children}
      </Toolbar>
    </AppBar>
  );
});
